// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__2CojQ","disabled":"FileBtn_disabled__1yh9P","warn":"FileBtn_warn__1Fied","fade":"FileBtn_fade__2aOSW"};